module.exports = __webpack_public_path__ + "static/media/buildingOff_326.8f01a71f.png";